module.exports = __webpack_public_path__ + "img/rethinking.78e8be48.jpg";